import React from "react";
import FadeIn from "react-fade-in";
import "./possibility.css";
import { Link } from "react-router-dom";

const Possibility = () => (
  <div className="gpt3__possibility section__padding" id="possibility">
    <div className="gpt3__possibility-image" />
    <div className="gpt3__possibility-content">
      <FadeIn animateIn="fadeInDown">
        <h1 className="gradient__text">
          Stop switching tabs. <br /> Start writing better papers.
        </h1>
        <p>
          Most writers lose hours jumping between their document, a browser full of research tabs,
          and a separate reference manager. WriteAI brings all of that into one place — so you can
          stay in flow and produce higher quality work in less time.
        </p>
      </FadeIn>
      <Link to="/authentication/sign-up">
        <h4>Start writing for free →</h4>
      </Link>
    </div>
  </div>
);

export default Possibility;
